import React, { useRef } from 'react';
import Modal from '../shared/Modal';

const DeleteTemplateModal = ({ isOpen, onClose, onConfirm, templateName }) => {
    const cancelRef = useRef(null);
    const confirmRef = useRef(null);

    const modalActions = (
        <>
            <button
                ref={cancelRef}
                onClick={onClose}
                className="flex-1 bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-gray-200 font-bold py-2 px-4 rounded hover:bg-gray-400 dark:hover:bg-gray-600"
            >
                Annuler
            </button>
            <button
                ref={confirmRef}
                onClick={onConfirm}
                className="flex-1 bg-red-600 dark:bg-red-500 text-white font-bold py-2 px-4 rounded hover:bg-red-700 dark:hover:bg-red-600"
            >
                Supprimer
            </button>
        </>
    );

    return (
        <Modal 
            open={isOpen} 
            onClose={onClose} 
            title="Supprimer le modèle"
            actions={modalActions}
            initialFocusRef={confirmRef}
        >
            <p className="mb-4 text-black dark:text-gray-300">
                Êtes-vous sûr de vouloir supprimer le modèle{' '}
                <strong className="text-gray-900 dark:text-white">"{templateName}"</strong> ?
            </p>
            {/* Avertissement */}
            <div className="p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded">
                <p className="text-sm text-yellow-800 dark:text-yellow-300">
                    ⚠️ Cette action est irréversible.
                </p>
            </div>
        </Modal>
    );
};

export default DeleteTemplateModal;
